<div class="box-sidebar">
    <div class="box-logo text-center">
        <!-- <img width="100%" src="./assets/logo/package.png" alt=""> -->
    </div>
    <div class="banner">
        <span class="material-symbols-outlined" (click)="closeSide()">
            close
        </span>
        <div class="logo" *ngIf="statusMenu"><img src="./../../../../../assets/logo/navbar.svg" alt=""></div>
    </div>
    <ul class="scrollbar menu">
        <li *ngFor="let menu of menuItem">
            <div class="box-item rd m-action d-inline-flex"
                [ngClass]="{'action': menu.active == true,'mini':!statusMenu}" (click)="toURL(menu)">
                <span class="material-symbols-outlined" [ngClass]="{'me-2':statusMenu}">
                    {{menu.Icon}}
                </span>
                <span [ngClass]="{'d-none':!statusMenu}">{{menu.Name}}</span>
            </div>
        </li>
    </ul>
</div>